import { apiInstances } from '../../../../libs';

const { get } = apiInstances.userInstance;

export default async function getCities() {
  return await get('/clouders/cities');
}
